export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "@id": "https://scienzahealth.com/#faq",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Digital Human® AI technology?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Digital Human® AI is an advanced artificial intelligence platform that creates lifelike digital representations capable of natural conversation and interaction. Our technology enables automated patient screening, clinical support, and healthcare delivery optimization."
      }
    },
    {
      "@type": "Question", 
      "name": "How does Scienza Health improve patient access?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Scienza Health automates patient access through AI-powered screening, intelligent triage, and streamlined intake processes. Our Digital Human® technology provides 24/7 availability for patient interactions while reducing administrative burden on healthcare staff."
      }
    },
    {
      "@type": "Question",
      "name": "Is the cognitive screening clinically validated?", 
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our cognitive screening tools are built on clinically validated assessments and integrate with established healthcare protocols. The platform supports evidence-based decision making while maintaining compliance with healthcare standards."
      }
    },
    {
      "@type": "Question",
      "name": "How secure is patient data with Scienza Health?",
      "acceptedAnswer": {
        "@type": "Answer", 
        "text": "Scienza Health maintains the highest standards of data security and privacy, including HIPAA compliance. All patient interactions and data are encrypted and processed through secure, healthcare-grade infrastructure."
      }
    },
    {
      "@type": "Question",
      "name": "Can Scienza Health integrate with existing EHR systems?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our platform is designed to integrate seamlessly with major EHR systems and existing healthcare workflows. We provide APIs and integration tools to ensure smooth deployment without disrupting current operations."
      }
    }
  ]
};